import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { Flex, Text, Box } from '../components';
import { humanReadableDateString } from '../../../assets/js/utils';

class ViewSigningResult extends React.Component {
  getSecurePDFLink(digestKey) {
    return `${APIHOST}/v1/onboarding/signing/hr/employee_onboarding_offers/${digestKey}/signed_offer`;
  }

  getSecureZipLink(digestKey) {
    return `${APIHOST}/v1/onboarding/signing/hr/employee_onboarding_offers/${digestKey}/signed_offer_zip`;
  }

  renderAction(signed, overlayText, icon, url) {
    const actionIcon = (
      <Tooltip overlay={overlayText} placement="top">
        <Flex align="center" style={{ height: '100%' }}>
          <img src={icon} />
        </Flex>
      </Tooltip>
    );

    if (signed) {
      return (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {actionIcon}
        </a>
      );
    }
    return actionIcon;
  }

  render() {
    const { action } = this.props;
    const index = action.sequence;
    let offer;
    let offerSigners;
    let name;
    let date;
    if (action.action_type === 'employee_sign_company_document' || action.action_type === 'hr_sign_company_document') {
      offer = action.employee_onboarding_offer;
      offerSigners = offer.offer_signers;
      name = offerSigners[index].signer_name;
      date = offerSigners[index].updated_at;
    } else {
      offer = action.offer;
      offerSigners = offer.offer_signers;
      name = offerSigners[0].name;
      date = offerSigners[0].date;
    }

    const offerDigestKey = offer.digest_key;
    const offerStatus = offer.status;

    const dateText = humanReadableDateString(date);

    const pdfURL = this.getSecurePDFLink(offerDigestKey);
    const zipURL = this.getSecureZipLink(offerDigestKey);

    const signed = offerStatus === 'signed';
    const previewOverlay = signed ? 'Preview documents as PDF' : 'Preview available after all signers have signed the document.';
    const downloadOverlay = signed ? 'Download signed documents' : 'Download available after all signers have signed the document.';
    const previewIcon = signed ? '/j/images/onboarding/preview.svg' : '/j/images/onboarding/preview-disabled.svg';
    const downloadIcon = signed ? '/j/images/onboarding/download.svg' : '/j/images/onboarding/download-disabled.svg';

    return (
      <Flex column>
        <Flex column style={{ width: '368px', margin: 'auto' }}>
          <Flex mb={20}>
            <Text fontSize="22px" bold>{this.props.title}</Text>
          </Flex>
          <Flex alignItems="center">
            <Text>
              {name}
              {' '}
              signed on
              {' '}
              {dateText}
            </Text>
            <Flex ml={2}>
              {this.renderAction(signed, previewOverlay, previewIcon, pdfURL)}
              <Box ml={1} />
              {this.renderAction(signed, downloadOverlay, downloadIcon, zipURL)}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

export default ViewSigningResult;
